import User from '@/domain/user/user.entity';
import WorkItemType from '@/domain/work-item/work-item-type.entity';

export default class FilterFields {
    public members: User[] = [];

    public originSystems: string[] = [];

    public workItemTypesMapper: string[] = [];

    public workItemTypes: WorkItemType[] = [];

    public workItemStatus: string[] = [];

    public get memberUsernames() {
      return this.members.map(member => member.username);
    }

    public get formatedStatus() {
      return this.workItemStatus.map(status => status.toUpperCase());
    }

    public get workItemTypeNames() {
      return this.workItemTypes.map(workItemType => workItemType.name);
    }
}
